export const VERTICAL_PADDING = 10;
export const HORIZONTAL_PADDING = 20;
